module.exports = __webpack_public_path__ + "img/user.e1caeccc.jpg";